import styled from 'styled-components'
import { Flex } from '@pulsex/uikit'

const StyledPage = styled.div<{ $removePadding: boolean; $noMinHeight: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 86px;
  padding-bottom: 30px;
  min-height: ${({ $noMinHeight }) => ($noMinHeight ? 'initial' : 'calc(100vh - 119px)')};
  background: ${({ theme }) => theme.colors.gradientBubblegum};

  ${({ theme }) => theme.mediaQueries.xs} {
    background-size: auto;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-top: 124px;
    padding-bottom: 30px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding-top: 132px;
    padding-bottom: 30px;
    min-height: ${({ $noMinHeight }) => ($noMinHeight ? 'initial' : 'calc(100vh - 119px)')};
  }
`

const Page: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { 
    removePadding?: boolean
    noMinHeight?: boolean 
  }
> = ({ children, removePadding = false, noMinHeight = false, ...props }) => {
  return (
    <>
      <StyledPage $removePadding={removePadding} $noMinHeight={noMinHeight} {...props}>
        {children}
        <Flex flexGrow={1} />
      </StyledPage>
    </>
  )
}

export default Page
